// libs
import React, {useState} from 'react';
// components
import ConfirmationBox from '../../components/confirmation-box';
import PrintErrorMsg from '../../components/print-error-msg';
import Button from 'react-bootstrap/Button';
import { formatSizeLabel } from '../../utils/size-label';
// config & functions 
import config from '../../config';

function Table({loadapidata, list, urlAccountId, orgInfo, token, onOpenFormModal}) {
    const [ShowDeleteModalBox, setShowDeleteModalBox] = useState(false);
    const [RowId, setRowId] = useState(0);
    const deleteUrl = `${config.api.generic}/size`;

    const handleDelete = (rowId) => {
        setRowId(rowId);
        setShowDeleteModalBox(true);
    }

    const handleUpdate = (rowId) => {
        if (onOpenFormModal) {
            onOpenFormModal(rowId);
        }
    }

    if(list && Array.isArray(list) && list.length > 0) {
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <thead>
                        <tr>
                            <th style={{minWidth: '50px'}}>#</th>
                            <th style={{minWidth: '120px'}}>Value</th>
                            <th style={{minWidth: '100px'}}>Unit</th>
                            <th style={{minWidth: '140px'}}>Display</th>
                            <th style={{minWidth: '80px'}}>Sort</th>
                            <th style={{minWidth: '90px'}}>Variants</th>
                            <th style={{minWidth: '160px'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((data, i) => {
                            return <tr key={data.pk_id}>
                                <td>{i + 1}</td>
                                <td><span className="fw-bold">{data.label}</span></td>
                                <td>{data.unit || '—'}</td>
                                <td>{formatSizeLabel(data)}</td>
                                <td>{data.sort_order}</td>
                                <td>{data.variant_count ?? 0}</td>
                                <td>
                                    {(orgInfo.roleId === 1 || orgInfo.roleId === 2) ? <>
                                        <Button variant="secondary" onClick={() => handleUpdate(data.pk_id)} className="fs-14rem me-3 p-0 border-0 bg-transparent text-primary">Update</Button>
                                        <Button variant="secondary" onClick={() => handleDelete(data.pk_id)} className="fs-14rem p-0 border-0 bg-transparent text-danger">Delete</Button>
                                    </> : null}
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowDeleteModalBox) ? <ConfirmationBox loadapidata={loadapidata} apidataparams={null} setshowdeletemodalbox={setShowDeleteModalBox} url={deleteUrl} params={{id: RowId, accountId: urlAccountId}} token={token} /> : null}
        </>
    } else {
        return <PrintErrorMsg msg={'No sizes yet. Click ADD SIZE to create one.'} />;
    }
}

export default Table;
